module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-void"
  }, [_c('ModalReveal', [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Usage details")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v(" CR" + _vm._s(_vm.item.id) + " ")]), _c('h4', [_vm._v(_vm._s(_vm.item.reason))]), _c('Cards', {
    attrs: {
      "data": _vm.creditData
    }
  })], 1), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "data-loader": _vm.dataLoader,
      "componentType": "usages"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2d24690!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/CrediRecordUsageReveal.vue
// module id = 2742
// module chunks = 1